import React, { useState, useEffect, useRef, useCallback } from "react";

import { Form } from "@unform/web";
import {
  FormGroup,
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import {
  Checkbox,
  DefaultSelect,
  DefaultInput,
  ToggleButton,
  Button,
} from "ui-kit-takeat";

import NotificationAlert from "react-notification-alert";

import Input from "../../components/Input";
import Select from "../../components/Form/SelectInput";
import Avatar from "./Avatar";

import { Card, CheckBoxArea } from "./styles";

import apiGd from "../../../services/apiGd";
import history from "../../../services/history";

export default function NewMultistores() {
  const formRef = useRef(null);

  const notificationAlert = useRef(null);
  const notify = (place, color, message) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: color,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7,
    };
    notificationAlert.current.notificationAlert(options);
  };

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState('');

  const [availableRestaurants, setAvailableRestaurants] = useState([]);
  const [users, setUsers] = useState([]);
  const [multistore, setMultistore] = useState({
    fantasy_name: "",
    name: "",
    email: "",
    password: "",
    child_store_id: null,

    controls_cost_center: false,
    controls_stock: false,
    controls_menu: false,

    responsible_user_id: null,
  });
  const [responsibleUser, setResponsibleUser] = useState(null);
  const [avatar, setAvatar] = useState(null);

  const getUsers = useCallback(async () => {
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");

      const res = await apiGd.get("/restaurants/users", {
        headers: {
          Authorization: `Bearer: ${token}`,
        },
      });

      // Removendo o usuario Admin/Padrao do nosso dash
      const users = res.data
        .filter((data) => data.id !== 1)
        .map((data) => {
          return {
            label: data.name,
            value: data.id,
          };
        });

      setUsers(users);
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
    }
  }, []);

  const getAvailableRestaurants = useCallback(async () => {
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");

      const res = await apiGd.get("/admin/multistores/available-restaurants", {
        headers: {
          Authorization: `Bearer: ${token}`,
        },
      });

      // Removendo o usuario Admin/Padrao do nosso dash
      const restaurants = res.data
        .map((data) => {
          return {
            label: data.name,
            value: data.id,
          };
        });

      setAvailableRestaurants(restaurants);
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
    }
  }, []);

  useEffect(() => {
    getAvailableRestaurants();
    getUsers();
  }, []);

  function handleSetAvatar(fn) {
    const { avatar_id } = fn({});

    setAvatar({ id: avatar_id });
  }

  async function handleSubmit(data) {
    const restaurantData = {
      ...multistore,
      ...data,
      responsible_user_id: responsibleUser?.value || null,
      regime_tributario: '1',
      is_location_limited: false,
      has_clube: false,
      cnpj: false,
      adress: {
        city: data.city || null,
        neighborhood: data.neighboorhood || null,
        state: data.state || null,
        street: data.street || null,
        zip_code: data.zip_code || null,
        number: data.number || -1,
      },
      delivery_info: {
        is_withdrawal_allowed: false,
        allow_delivery_addresses: false,
      },
      settings: {
        has_balcony: false,
        use_smart_pos: false,
        plan: 'BÁSICO',
        use_tablet: false,
        has_stone_pdv: false,
        use_ifood_pdv_code: false,
        wpp_report_active: false,
        use_balance: false,
        use_totem: false,
        is_markup_allowed: false,
      },
    };

    if (avatar) {
      restaurantData.avatar_id = avatar.id;
    }

    if (
      restaurantData.controls_menu ||
      restaurantData.controls_stock ||
      restaurantData.controls_cost_center
    ) {
      if (!restaurantData.child_store_id) {
        notify("tr", "danger", "Preencha o campo de loja filha");
        return false;
      }
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      setLoadingMsg('Criando restaurante');
      const { data: createdMultistore } = await apiGd.post(
        "restaurants",
        restaurantData,
        reqConfig
      );

      setLoadingMsg('Configrando Multilojas');
      await apiGd.post(
        "/admin/multistores/configure",
        {
          restaurant_id: createdMultistore.id,
          controls_cost_center: restaurantData.controls_cost_center || false,
          controls_stock: restaurantData.controls_stock || false,
          controls_menu: restaurantData.controls_menu || false,
        },
        reqConfig
      );

      setLoadingMsg('Adicionando loja filha');

      const has_default_cloning =
        restaurantData.controls_stock || restaurantData.controls_menu;

      if (has_default_cloning) {
        const cloneConfig = {
          restaurant_id1: data.child_store_id,
          restaurant_id2: createdMultistore.id,
          only_inputs: false,
          only_menu: false,
        };
        
        if (restaurantData.controls_stock && !restaurantData.controls_menu) {
          cloneConfig.only_inputs = true;
        } 
        if (!restaurantData.controls_stock && restaurantData.controls_menu) {
          cloneConfig.only_menu = true;
        }

        await apiGd.post(
          "/admin/restaurants/multistores/clone-menu-from-child",
          cloneConfig,
          reqConfig
        );
      } else {
        if (!restaurantData.controls_cost_center) {
          const cloneConfig = {
            multistore_id: createdMultistore.id,
            restaurant_id: data.child_store_id,
          };

          await apiGd.post(
            "/admin/multistores/add-child-store",
            cloneConfig,
            reqConfig
          );
        } else {
          // Se o multilojas só controla o centro de custo, podemos apenas clonar os insumos 
          // do multilojas para a loja filha, isso clona apenas os centros de custo
          const cloneConfig = {
            restaurant_id1: createdMultistore.id,
            restaurant_id2: data.child_store_id,
            only_inputs: true,
          };

          await apiGd.post(
            "/admin/restaurants/multistores/clone-menu",
            cloneConfig,
            reqConfig
          );
        }
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
      notify("tr", "danger", "Erro ao criar o estabelecimento.");
    }
  }

  return (
    <>
      <NotificationAlert ref={notificationAlert} />
      <div className="content">
        <Row style={{ flexDirection: "row" }}>
          <Button
            onClick={() => history.goBack()}
            title="Voltar"
            buttonColor="#333333"
            style={{ width: 100, marginRight: '20px' }}
          />
          <h3> Cadastro de Multilojas </h3>

        </Row>
        <Row>
          <Form
            initialData={multistore}
            className="form-horizontal"
            style={{ width: '100%' }}
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Card>
              <Col md="12">
                <Row style={{ marginTop: 10 }}>
                  <Col md="9">
                    <Row style={{ flexDirection: "column" }}>
                      <span style={{ fontWeight: "bold" }}>Nome</span>
                      <Input
                        type="text"
                        name="fantasy_name"
                        title="Nome de exibição"
                      />
                    </Row>
                    <Row style={{ marginTop: 10, flexDirection: "column" }}>
                      <span style={{ fontWeight: "bold" }}>Nome de usuário</span>
                      <Input
                        title="Nome de usuário"
                        type="text"
                        name="name"
                      />
                      <span>
                        Esse nome é um identificador único do estabelecimento, deve
                        ter letras minúsculas e sem espaço. Ex: 'mcdonalds' / 'bobs'
                        / 'burgerking'
                      </span>
                    </Row>
                    <Row style={{ marginTop: 10, flexDirection: "column" }}>
                      <span style={{ fontWeight: "bold" }}>Email</span>
                      <Input
                        type="email"
                        name="email"
                        title="Email"
                        autocomplete="new-password"
                      />
                    </Row>
                    <Row style={{ marginTop: 10, flexDirection: "column" }}>
                      <span style={{ fontWeight: "bold" }}>Senha</span>
                      <Input
                        type="password"
                        name="password"
                        autocomplete="new-password"
                        title="Senha"
                      />
                    </Row>
                    <Row style={{ marginTop: 10, flexDirection: "column" }}>
                      <Select
                        label="Vendedor responsável"
                        name="responsible_user_id"
                        options={users}
                        value={responsibleUser}
                        onChange={(e) => {
                          const user = users.find((u) => u.value === e.value);
                          setResponsibleUser(user);
                          console.log(user);
                        }}
                      />
                    </Row>
                  </Col>
                  <Col md="3">
                    <Row
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Col>
                          <Avatar
                            ref={formRef}
                            name="avatar"
                            setRestaurantData={handleSetAvatar}
                            value={avatar}
                          />

                          <CheckBoxArea>
                            <p> Controle </p>

                            <Checkbox
                              label="Controle de cardápio"
                              name="controls_menu"
                              checked={multistore.controls_menu}
                              onClick={(value) => setMultistore((prev) => ({ ...prev, controls_menu: value }))}
                            />

                            <Checkbox
                              label="Controle de estoque"
                              name="controls_stock"
                              checked={multistore.controls_stock}
                              onClick={
                                (value) => setMultistore((prev) =>
                                  ({
                                    ...prev,
                                    controls_stock: value,
                                    controls_cost_center: prev.controls_cost_center || value,
                                  })
                                )
                              }
                            />

                            <Checkbox
                              label="Controle de Centro de Custo"
                              name="controls_cost_center"
                              checked={multistore.controls_cost_center}
                              onClick={
                                (value) => setMultistore((prev) =>
                                  ({ ...prev, controls_cost_center: prev.controls_stock || value })
                                )
                              }
                            />
                          </CheckBoxArea>
                          <Select
                            label="Primeira loja filha"
                            name="child_store_id"
                            options={availableRestaurants}
                          />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col md="12" style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button
                      color="success"
                      type="submit"
                      title="Cadastrar"
                      buttonColor="#2ec9b7"
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
          </Form>
        </Row>
      </div>

      <Modal isOpen={loading}>
        <ModalHeader> Aguarde </ModalHeader>
        <ModalBody>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
           <Spinner color="danger" />
            <div style={{ marginLeft: 10 }}> {loadingMsg} </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
